export default function Mada(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={24} {...props}>
      <g data-name="Mada_Logo">
        <path
          data-name="Rectangle 2068"
          fill="#84b740"
          d="M0 13.061h20.304v6.764H0z"
        />
        <path
          data-name="Rectangle 2069"
          fill="#259bd6"
          d="M0 3.831h20.304v6.77H0z"
        />
        <path
          data-name="Path 2779"
          d="m40.608 18.45-.091.018a2.96 2.96 0 0 1-.657.084c-.53 0-1.157-.271-1.157-1.549 0-.657.109-1.531 1.1-1.531h.006a2.971 2.971 0 0 1 .724.139l.078.024v2.815Zm.163-6.372-.163.03v2.363l-.145-.042-.042-.012a3.325 3.325 0 0 0-.9-.157c-1.978 0-2.393 1.5-2.393 2.749a2.438 2.438 0 0 0 2.647 2.707 5.364 5.364 0 0 0 1.766-.247.78.78 0 0 0 .663-.856v-6.782c-.47.084-.959.169-1.435.247"
          fill="#27292d"
        />
        <path
          data-name="Path 2780"
          d="m46.487 18.492-.084.024-.3.078a3.145 3.145 0 0 1-.729.115c-.464 0-.742-.229-.742-.621 0-.253.115-.681.874-.681h.983Zm-.693-4.262a6.672 6.672 0 0 0-2.014.35l-.506.151.169 1.145.494-.163a5.812 5.812 0 0 1 1.646-.277c.217 0 .88 0 .88.717v.314h-.922c-1.682 0-2.46.537-2.46 1.688 0 .983.717 1.573 1.923 1.573a6.217 6.217 0 0 0 1.338-.181l.024-.006.024.006.151.024c.47.084.959.169 1.435.259v-3.762c0-1.218-.736-1.839-2.182-1.839"
          fill="#27292d"
        />
        <path
          data-name="Path 2781"
          d="m34.773 18.492-.084.024-.3.078a3.1 3.1 0 0 1-.729.115c-.464 0-.741-.229-.741-.621 0-.253.115-.681.868-.681h.983l.006 1.085Zm-.687-4.262a6.642 6.642 0 0 0-2.013.35l-.506.15.169 1.145.494-.163a5.812 5.812 0 0 1 1.646-.277c.217 0 .88 0 .88.717v.314h-.922c-1.682 0-2.466.537-2.466 1.688 0 .983.717 1.573 1.929 1.573a6.215 6.215 0 0 0 1.338-.181l.024-.006.024.006.145.024c.476.084.959.169 1.435.265v-3.762c.006-1.23-.729-1.845-2.176-1.845"
          fill="#27292d"
        />
        <path
          data-name="Path 2782"
          d="M28.425 14.242a4.069 4.069 0 0 0-1.634.362l-.06.03-.054-.042a2.473 2.473 0 0 0-1.465-.356 5.993 5.993 0 0 0-1.73.259c-.512.157-.711.4-.711.868v4.3h1.6V15.69l.078-.024a2.041 2.041 0 0 1 .705-.127.634.634 0 0 1 .7.729v3.4h1.579v-3.466a1.164 1.164 0 0 0-.048-.35l-.054-.1.109-.048a1.9 1.9 0 0 1 .784-.163.639.639 0 0 1 .7.729v3.4h1.573v-3.557c0-1.26-.675-1.869-2.074-1.869"
          fill="#27292d"
        />
        <path
          data-name="Path 2783"
          d="M45.305 8.244a5.47 5.47 0 0 1-.934-.084l-.091-.018V5.82a1.129 1.129 0 0 0-.042-.332l-.048-.1.1-.042c.024-.012.048-.018.078-.03l.018-.012.109-.036a.153.153 0 0 1 .042-.012 3.742 3.742 0 0 1 .826-.1h.006c.983 0 1.1.874 1.1 1.531-.006 1.278-.639 1.549-1.163 1.549m-.007-4.405h-.042a2.84 2.84 0 0 0-2.206.748 1.508 1.508 0 0 0-.289.9V7.87a.705.705 0 0 1-.048.3l-.054.1h-2.912V6.61h-.006a2.48 2.48 0 0 0-2.576-2.719h-1.465c-.06.428-.109.729-.169 1.157h1.459c.766 0 1.17.651 1.17 1.652v1.677l-.1-.054a1.107 1.107 0 0 0-.344-.048h-2.52c-.048.32-.109.735-.175 1.151h7.747c.265-.054.573-.1.838-.145a4.364 4.364 0 0 0 1.622.3 2.645 2.645 0 0 0 2.773-2.864 2.659 2.659 0 0 0-2.703-2.886"
          fill="#27292d"
        />
        <path
          data-name="Path 2784"
          d="M31.716 10.131h.072c1.682 0 2.466-.555 2.466-1.923a1.761 1.761 0 0 0-1.923-1.766h-1.549a.668.668 0 0 1-.742-.711c0-.3.115-.675.874-.675h3.388c.072-.44.109-.717.175-1.157h-3.521c-1.64 0-2.466.687-2.466 1.833s.717 1.724 1.923 1.724h1.549a.732.732 0 0 1 .742.754.757.757 0 0 1-.868.778h-.259l-4.962-.012h-.9c-.766 0-1.3-.434-1.3-1.441v-.696c0-1.049.416-1.7 1.3-1.7h1.471l.169-1.151h-2.008a2.515 2.515 0 0 0-2.577 2.761v.784a2.379 2.379 0 0 0 2.574 2.592h1.465l2.689.006h2.218Z"
          fill="#27292d"
        />
      </g>
    </svg>
  );
}
